export default {
    namespaced:true,
    state: {
        env: '',
        credentials: [],
        openId: '',
        name: '',
        avatar: '',
        pos: '',
        mobile: '',
        token: '',
        userId: 0
    },
    mutations: {
        sync(state, payload) {
            // console.log('ss-sync--22', payload);
            state.userId        = payload.userId;
            state.name          = payload.name;
            state.openId        = payload.openId;
            state.avatar        = payload.avatar;
            state.mobile        = payload.mobile;
            state.pos           = payload.pos;
            state.token         = payload.token;
            state.credentials   = payload.credentials;
            if (undefined !== payload.env) {
                state.env = payload.env;
            }
        }
    },
    getters: {
        isLoggedIn: state => {
            return  state.userId > 0;
        },
        userId: state => {
            return state.userId;
        },
        userInfo: state => {
            return {
                env: state.env,
                userId: state.userId,
                openId: state.openId,
                pos: state.pos,
                name: state.name,
                credentials: state.credentials,
                mobile: state.mobile,
                token: state.token,
                avatar: state.avatar
            };
        },
        env: state => {
            return state.env;
        },
        credentials: state => {
            return state.credentials;
        }
    },
    actions: {
        sync({commit}, changed) {
            commit('sync', changed);
        }
    }

};
